import axios from '../../config/axiosConfig';
import {
    GET_STATES,
    STATE_REQUEST,
    STATE_REQUEST_FAILURE,
    CREATE_STATE, DELETE_STATE, UPDATE_STATE,
} from '../types';

export const getStates = () => {
    return async (dispatch, getState) => {
        const { auth } = getState();
        try {
            return axios.get('/state/getAll',{ params: { userId: auth?.superUser?.id }}).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_STATES, payload: response.data });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: STATE_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: STATE_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const createState = (state) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: STATE_REQUEST });
            const { auth } = getState();
            return axios.post("/state/add", state, { params: { userId: auth?.superUser?.id } }).then((response) => {
                if (response.data) {
                    dispatch({ type: CREATE_STATE, payload: response.data });
                    // dispatch(getStates());
                } else {
                    dispatch({
                        type: STATE_REQUEST_FAILURE,
                        error: "State create failed.",
                    });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: STATE_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: STATE_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const updateState = (id, stateData) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: STATE_REQUEST });
            const { auth } = getState();
            return axios.put('/state/update', { id, stateData }, { params: { userId: auth.superUser?.id }}).then((response) => {
                if (response.data) {
                    dispatch({ type: UPDATE_STATE, payload: { id, data: response.data } });
                } else {
                    dispatch({ type: STATE_REQUEST_FAILURE, error: 'State update failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: STATE_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: STATE_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const deleteState = (id) => {
    return async (dispatch) => {
        try {
            dispatch({ type: STATE_REQUEST });
            return axios.delete(`/state/delete/${id}`).then((response) => {
                if (response.data) {
                    dispatch({ type: DELETE_STATE, id: id });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: STATE_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: STATE_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};